var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"secondary","outline":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$store.commit('stepper/previousStep')}}},[_vm._v("\n    Zurück\n")])}
var staticRenderFns = []

export { render, staticRenderFns }